import React, { useEffect, useRef, useState } from "react";
//i18n
import { withNamespaces } from "react-i18next";
import exportFromJSON from "export-from-json";
import {
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  Container,
  Modal,
  ModalHeader,
  ModalBody,
  Button,
  Spinner,
} from "reactstrap";

// Redux
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";

//Import Breadcrumb
import Breadcrumb from "../../../../components/Common/Breadcrumb";
import filterFactory, { selectFilter } from "react-bootstrap-table2-filter";

import BootstrapTable from "react-bootstrap-table-next";
import "../../../../../node_modules/react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, {
  Search,
} from "react-bootstrap-table2-toolkit";

import { postSubmitForm } from "../../../../helpers/forms_helper";
import moment from "moment";
import { convertToLowestUnit, ExportAvailableInCSVForReports, exportFromula, formatUnitsForReport , GetUpdatedDelivered, mapUnits } from "../../../../helpers/units";
import printDiv from "../../../../helpers/print_data";
import showNotification from "../../../../helpers/show_notification";


const BranchwiseItemBalanceInventoriesReport = (props) => {

  const { SearchBar } = Search;
  const [selectedBranch, setSelectedBranch] = useState();
  const [selectedRow, setSelectedRow] = useState([]);
  const [grandTotal, setGrandTotal] = useState(0);
  const [filterModalSubTotal, setFilterModalSubTotal] = useState(0);
  const [filterModalTotalQty, setFilterModalTotalQty] = useState([]);
  const [itemDetailsModal, setItemDetailsModal] = useState(false);
  const [itemDetailsLevel2, setItemDetailsLevel2] = useState([]);
  const [isLoadingOrders, setIsLoadingOrders] = useState(false);
  const [isLoadingBranchDetails, setIsLoadingBranchDetails] = useState(false);
  const [isLoadingItemDetails, setIsLoadingItemDetails] = useState(false);
  const [tablePage, setTablePage] = useState(1);
  const [pageSize, setPageSize] = useState(50);
  const ordersRequestId = useRef(0);
  const searchSigRef = useRef("");

   function afterFilterForDetails(newData, quantityField) {
           const data = newData;
           let totalCost = 0;
           let totalLowestUnitQty = 0;
           
           data.forEach(item => {
             const { 
               receiving_cost = 0,
               unit_levels,
               quantity
             } = item || {};
         
             totalCost += Number(receiving_cost || 0);
         
             if (unit_levels) {
               const quantityToBeDisplayed = quantity;
         
               if (quantityToBeDisplayed) {
                 const convertedQty = convertToLowestUnit(unit_levels, quantityToBeDisplayed);
                 totalLowestUnitQty += Number(convertedQty || 0);
               }
             }
           });     
           let displayQuantity = "";
           const firstItemDetails = data[0];
           if (firstItemDetails?.unit_levels) {
             const { unit_levels } = firstItemDetails;
             const lowestUnit = unit_levels.at(-1).unit;
             
             const summedQuantity = [{
               unit: lowestUnit,
               value: totalLowestUnitQty
             }];
             
             displayQuantity = GetUpdatedDelivered(summedQuantity, unit_levels);
           }
           setFilterModalTotalQty(displayQuantity);
           setFilterModalSubTotal(totalCost.toFixed(2))
    }

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const storeId = params.get('store_id');
    if (storeId) {
      loadDataWithParams(storeId);
    } else {
      loadOrders();
    }
  }, []);

  const [allOrders, setAllOrders] = useState([]);
  const [filteredOrders, setFilteredOrders] = useState([]);
  const loadOrders = async () => {
   const requestId = ++ordersRequestId.current;
   try {
    setIsLoadingOrders(true);
    let url = process.env.REACT_APP_BASEURL + "reports/branchwise_balance_items";
    const response = await postSubmitForm(url, {});
    if (requestId !== ordersRequestId.current) return null;
    if (response && response.status === 1) {
      setGrandTotal(response.data.grand_total_cost);
      setAllOrders(response.data.branches || []);
      setFilteredOrders(response.data.branches || []);
      setTablePage(1);
      return response.data.branches;
    } else {
      showNotification(response && response.message, "Error");
      return null;
    }
   } catch (error) {
    if (requestId !== ordersRequestId.current) return null;
    console.log(error);
    return null;
   } finally {
    if (requestId === ordersRequestId.current) {
      setIsLoadingOrders(false);
    }
   }
  };

  const loadDataWithParams = async (storeId) => {
    const orders = await loadOrders(); 
    
    if (orders && storeId) {
      const selectedStore = orders.find(store => String(store._id) === String(storeId));
      if (selectedStore) {
        setSelectedBranch(selectedStore);
        await loadBranchwiseItemsDetails(selectedStore);
      }
    }
  };

  const [filterModalTotal, setFilterModalTotal] = useState(0);
  function afterFilter(newResult, newFilters) {
    const total = newResult.reduce(
      (partialSum, a) => Number(partialSum) + Number(a.receiving_cost),
      0
    );
    setFilterModalTotal(total.toFixed(2));
  }

   function afterSearch(newResult, newFilters) {
    const total = newResult.reduce(
      (partialSum, a) => Number(partialSum) + Number(a.item_cost),
      0
    );
    const sig = `${newResult.length}:${Number(total.toFixed(2))}`;
    setFilteredOrders((prevOrders) => {
      if (searchSigRef.current === sig) return prevOrders;
      searchSigRef.current = sig;
      return newResult;
    });

    setGrandTotal(Number(total.toFixed(2)));
  }

  const [itemModal, setItemModal] = useState(false);
  const loadBranchwiseItemsDetails = async (row) => {
    try {
      setSelectedBranch(row);
      setSelectedRow([]);
      setItemModal(true);
      setIsLoadingBranchDetails(true);
      let url = process.env.REACT_APP_BASEURL + "reports/branchwise_balance_items_details";
      const response = await postSubmitForm(url, {branch_id: row._id});
      if (response && response.status === 1) {
        setSelectedRow(response.data.items || []);
        setFilterModalTotal(response.data.grand_total_cost || 0);
      } else {
        showNotification(response && response.message, "Error");
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoadingBranchDetails(false);
    }
    };

    const loadItemDetails = async (item_id) => {
      try {
        setIsLoadingItemDetails(true);
        setItemDetailsLevel2([]);
        setItemDetailsModal(true);
        let url = process.env.REACT_APP_BASEURL + "reports/branchwise_balance_items_by_item";
        const response = await postSubmitForm(url, {
          branch_id: selectedBranch._id,
          item_id: item_id,
        });
        if (response && response.status === 1) {
                 const data = response.data || [];
                let totalReceivingCost = 0;
                let totalLowestUnitQty = 0;  
                
                data.forEach(item => {
                  const { 
                    receiving_cost = 0,
                    unit_levels,
                    quantity
                  } = item || {};
          
                  totalReceivingCost += Number(receiving_cost);
          
                  if (unit_levels && quantity) {
                    const convertedQty = convertToLowestUnit(unit_levels, quantity);
                    totalLowestUnitQty += Number(convertedQty || 0);
                  }
                });
          
                let displayQuantity = "";
                const firstDeliveryDetails = data[0]
                if (firstDeliveryDetails?.unit_levels) {
                  const { unit_levels } = firstDeliveryDetails;
                  const lowestUnit = unit_levels.at(-1).unit;
                  
                  const summedQuantity = [{
                    unit: lowestUnit,
                    value: totalLowestUnitQty
                  }];
                  
                  displayQuantity = GetUpdatedDelivered(summedQuantity, unit_levels);
                }
          setItemDetailsLevel2(data);
          setFilterModalSubTotal(totalReceivingCost || 0);
          setFilterModalTotalQty(displayQuantity);
        } else {
          showNotification(response && response.message, "Error");
        }
      } catch (error) {
        console.log(error);
      } finally {
        setIsLoadingItemDetails(false);
      }
    };
  const columns = [
    {
      dataField: "_id",
      hidden: true,
    },
    {
      dataField: "_id",
      formatter: (cell, row, rowIndex) => {
        return rowIndex + 1;
      },
      text: props.t("#"),
      headerStyle: (colum, colIndex) => {
        return { width: "5%" };
      },
    },

    {
      text: props.t("Name"),
      dataField: "name",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "18%" };
      },
    },

    {
      dataField: "item_cost",
      text: props.t("Item Cost (QR)"),
      sort: true,
      formatter: (cell, row, rowIndex) => {
        return (
          <span
            className="text-info mr-2"
            title="View Details"
            style={{ cursor: "pointer" }}
            onClick={() => {
              loadBranchwiseItemsDetails(row);
            }}
          >
            {row.item_cost}
          </span>
        );
      },
      headerStyle: (colum, colIndex) => {
        return { width: "18%" };
      },
    },
  ];

  const columnsItem = [
    {
      dataField: "item_id",
      hidden: true,
    },
    {
      dataField: "item_id",
      formatter: (cell, row, rowIndex) => {
        return rowIndex + 1;
      },
      text: props.t("#"),
      headerStyle: (colum, colIndex) => {
        return { width: "5%" };
      },
    },

    {
      text: props.t("Item"),
      dataField: "name",
      sort: true,
      formatter: (cell, row, rowIndex) => {
        return (
          <span
            className="text-info mr-2"
            title="View Details"
            style={{ cursor: "pointer" }}
            onClick={() => {
              loadItemDetails(row.item_id);
            }}
          >
            {row.name} <span hidden={!row.is_free} className="text-danger" style={{fontSize:"20px"}}>*</span>
            </span>
        );
      },
      headerStyle: (colum, colIndex) => {
        return { width: "20%" };
      },
    },
    // {
    //   text: props.t("Category"),
    //   dataField: "category",
    //   sort: true,
    //   headerStyle: (colum, colIndex) => {
    //     return { width: "15%" };
    //   },
    //   filter: selectFilter({
    //     options: () => {
    //       const unique = [
    //         ...new Map(
    //           [
    //             ...new Set(
    //               selectedRow?.map(({ category: value }) => ({
    //                 value: value,
    //                 label: value,
    //               }))
    //             ),
    //           ].map((item) => [item["value"], item])
    //         ).values(),
    //       ];

    //       unique.sort(dynamicSort("label"));
    //       return unique;
    //     },
    //   }),
    // },
    // {
    //   text: props.t("Sub-Category"),
    //   dataField: "sub_category",
    //   sort: true,
    //   headerStyle: (colum, colIndex) => {
    //     return { width: "15%" };
    //   },
    //   filter: selectFilter({
    //     options: () => {
    //       const unique = [
    //         ...new Map(
    //           [
    //             ...new Set(
    //               selectedRow?.map(({ sub_category: value }) => ({
    //                 value: value,
    //                 label: value,
    //               }))
    //             ),
    //           ].map((item) => [item["value"], item])
    //         ).values(),
    //       ];

    //       unique.sort(dynamicSort("label"));
    //       return unique;
    //     },
    //   }),
    // },
{
        dataField: "unit_levels",
        text: props.t("Formula"),
        sort: true,
        formatter: (cell, row) => {
          return mapUnits(row?.unit_levels);
        },
        headerStyle: (colum, colIndex) => {
          return { width: "10%" };
        },
      },
      {
        dataField: "quantity",
        text: props.t("Total Quantity."),
        formatter: (cell, row) => {
          return formatUnitsForReport(row.quantity)
  
        },
        sort: true,
        headerStyle: (colum, colIndex) => {
          return { width: "10%" };
        },
      },
 {
      text: props.t("Purchasing Unit"),
      dataField: "unit_for_po",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
    },
    // {
    //   dataField: "price",
    //   text: props.t("Price (QR)"),

    //   sort: true,
    //   headerStyle: (colum, colIndex) => {
    //     return { width: "5%" };
    //   },
    // },
    
    {
      dataField: "receiving_cost",
      text: props.t("Total Cost (QR)"),
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
    },
    // {
    //   dataField: "use_date",
    //   text: props.t("Date"),
    //   formatter: (cell, row) => {
    //     return moment(row.use_date).format("DD/MM/YYYY HH:mm");
    //   },
    //   sort: true,
    //   headerStyle: (colum, colIndex) => {
    //     return { width: "8%" };
    //   },
    // },
  ];

 const columnsItemDetails = [
    {
      dataField: "_id",
      hidden: true,
    },
    {
      dataField: "_id",
      formatter: (cell, row, rowIndex) => {
        return rowIndex + 1;
      },
      text: props.t("#"),
      headerStyle: (colum, colIndex) => {
        return { width: "5%" };
      },
    },
    {
      text: props.t("Item"),
      dataField: "name",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "20%" };
      },
      formatter: (cell, row) => {
        let po_id = row?.po_id
        return (
          <div>
            <div>{cell}</div>
               <small>
               {po_id ? (
                 <a
                   href={"/purchase_order?po_id=" + po_id}
                   target="_blank"
                   rel="noopener noreferrer"
                   className="text-info"
                 >
                   PO: {po_id}
                 </a>
               ) : (
                 <span className="text-muted fst-italic">
                   No PO - Manual Entry
                 </span>
               )}
             </small>
          </div>
        );
      }
    },
    {
      dataField: "unit_levels",
      text: props.t("Formula"),
      sort: true,
      formatter: (cell, row) => {
        return mapUnits(row.unit_levels);
      },
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
    },

    {
      dataField: "name",
      text: props.t("Quantity"),
      formatter: (cell, row) => {
        return formatUnitsForReport(row.quantity);
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
    },
    {
      dataField: "is_free",
      text: props.t("Free ?"),
      sort: false,
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
      formatter: (cell) => (cell ? "Yes" : "No"),
      filter: selectFilter({
        options: [
          { value: true, label: "Yes" },
          { value: false, label: "No" },
        ],
        placeholder: "All",
      }),
    },
    {
      dataField: "unit_for_po",
      text: props.t("Purchasing Unit"),
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },
    {
      dataField: "price",
      text: props.t("Price (QR)"),
      // formatter: (cell,row)=>{
      //   return row?.cost_price + "/" + row?..unit_for_po
      //  },
      formatter: (cell, row) => {
        if (row?.is_free) {
          return (row?.free_cost_price);
        } else {
          return (row?.price);
        }
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
    },
    {
      dataField: "receiving_cost",
      text: props.t("Receiving Cost"),
      formatter: (cell, row) => {
        if (row?.is_free) {
          return (
            <div>
              <div>Projected: {row?.projected_cost}</div>
            </div>
          );
        } else {
          return (row?.receiving_cost)
        }
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
    },

    {
      dataField: "created_at",
      text: props.t("Date"),
      formatter: (cell, row) => {
        return moment(row.created_at).format(
          "DD/MM/YYYY HH:mm"
        );
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "14%" };
      },
    },
  ];

  const customTotal = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total">
      {" "}
      Showing {from} - {to} of {size} records.
    </span>
  );
  const pagination_options = {
    page: tablePage,
    sizePerPage: pageSize,
    onPageChange: (page, sizePerPage) => {
      setTablePage(page);
      setPageSize(sizePerPage);
    },
    paginationSize: 5,
    pageStartIndex: 1,
    firstPageText: "First",
    prePageText: "Prev",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    paginationTotalRenderer: customTotal,
    disablePageTitle: true,
    sizePerPageList: [
      { text: "50", value: 50 },
      { text: "100", value: 100 },
      { text: "200", value: 200 },
    ],
    hideSizePerPage: false,
    ignoreSinglePage: true,
  };

  const handleDownload = async () => {
    const fileName = "branchwise_item_balance_report_";
    const exportType = "xls";

    let data_to_export = filteredOrders;

    if (data_to_export) {
      var data = [];
      data_to_export.forEach(function (v) {
        data.push({
          Name: v.name,
          ItemCost: v.item_cost,
        });
      });

      exportFromJSON({ data, fileName, exportType });
    }
  };

  const handleDownloadModalData = async () => {
    const fileName = "branchwise_item_balance_detail_report_";
    const exportType = "xls";

    let data_to_export = selectedRow;

    if (data_to_export) {
      var data = [];
      data_to_export.forEach(function (v) {
          data.push({
                 Item: v.name,
                 Formula: v.unit_levels && exportFromula(v.unit_levels),
                 "Total Quantity":ExportAvailableInCSVForReports(v.quantity),
                 "Purchasing Unit": v.unit_for_po,
                 "Total Cost": v.receiving_cost,
              });
      });

      exportFromJSON({ data, fileName, exportType });
    }
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumb
            alternateTitle={props.t("Branchwise Balance Item Report")}
            title={props.t("Reports")}
            breadcrumbItem={props.t("Branchwise Balance Item Report")}
          />

          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <Row className="mb-2">
                    <Col sm="4">
                      <Button
                        type="submit"
                        className="btn btn-sm btn-secondary"
                        onClick={handleDownload}
                      >
                        <i className="mdi mdi-file-export"></i>{" "}
                        {props.t("Export CSV")}
                      </Button>
                      {"   "}
                      <Link
                        to="#"
                        onClick={() => {
                          printDiv("printDiv");
                        }}
                        className="btn btn-sm btn-success mr-2"
                      >
                        <i className="fa fa-print"></i> Print
                      </Link>
                      <div className="search-box mr-2 mb-2 d-inline-block">
                        <div className="position-relative"></div>
                      </div>
                    </Col>
                  </Row>
                  <div id="printDiv">
                    <CardTitle className="text-center">
                      {props.t("Branchwise Balance Item Report")}{" "}
                    </CardTitle>
                    <ToolkitProvider
                      keyField="_id"
                      data={allOrders && allOrders}
                      columns={columns}
                      bootstrap4
                      search
                    >
                      {(toolkitProps) => (
                        <div>
                          <Row>
                            <Col lg={4}>
                              <SearchBar
                                {...toolkitProps.searchProps}
                                style={{ width: "300px" }}
                                delay={500}
                                 onSearch={(searchText) => {      
                                  if (!searchText || searchText.trim() === '') {
                                toolkitProps.searchProps.onSearch(searchText);
                                afterSearch(toolkitProps.baseProps.data); 
                                return
                                  }
                                  if(searchText?.length <= 3) 
                                    return                      
                                  const searchResult = toolkitProps.baseProps.data?.filter(row => {
                                  const matchesSearch = (value) => {
                                    if (value === null || value === undefined) return false;
                                    if (typeof value === 'object') {
                                      return Object.values(value).some(v => matchesSearch(v));
                                    }
                                    return String(value).toLowerCase().includes(searchText.toLowerCase());
                                  };
                                  return Object.values(row).some(matchesSearch);
                                });
                                
                                toolkitProps.searchProps.onSearch(searchText);
                                afterSearch(searchResult);
                                }}
                              />
                            </Col>
                            <Col lg={4}></Col>
                            <Col lg={4}>
                              <h5> Grand Total : QR {grandTotal.toLocaleString('en-QA', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2
})}</h5>
                            </Col>
                          </Row>
                          <BootstrapTable
                            striped
                            hover
                            condensed
                            pagination={paginationFactory(pagination_options)}
                            noDataIndication={
                              isLoadingOrders ? (
                                <Spinner size="md" />
                              ) : (
                                props.t("No data to display.")
                              )
                            }
                            {...toolkitProps.baseProps}
                          />
                        </div>
                      )}
                    </ToolkitProvider>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>

          {/* Item breakup modal       */}
          <Modal
            size="xl"
            isOpen={itemModal}
            toggle={() => setItemModal(!itemModal)}
          >
            <ModalHeader toggle={() => setItemModal(!itemModal)}>
              {"   "}
              <Button
                type="submit"
                className="btn btn-sm btn-secondary"
                onClick={handleDownloadModalData}
              >
                <i className="mdi mdi-file-export"></i> {props.t("Export CSV")}
              </Button>
              <Link
                to="#"
                onClick={() => {
                  printDiv("printDiv1");
                }}
                style={{ marginLeft: "10px" }}
                className="btn btn-sm btn-success mr-2"
              >
                <i className="fa fa-print"></i> Print
              </Link>
            </ModalHeader>
            <ModalBody>
              <Row>
                <Col lg={12}>
                  <Card>
                    <CardBody>
                      <Row id="printDiv1">
                        <Col lg={12}>
                          <CardTitle className="text-center">
                            {" "}
                            {props.t("Item Details")}{" "}
                          </CardTitle>
                          <h5>
                            Branch : {selectedBranch?.name} | Total :{" "}
                            {Number(filterModalTotal).toLocaleString('en-QA', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2
})}
                          </h5>
                          <BootstrapTable
                            keyField="item_id"
                            data={selectedRow|| []}
                            columns={columnsItem}
                            striped
                            hover
                            bootstrap4
                            condensed
                            filter={filterFactory({ afterFilter })}
                            noDataIndication={
                              isLoadingBranchDetails ? (
                                <Spinner size="md" />
                              ) : (
                                props.t("No data to display.")
                              )
                            }
                          />
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </ModalBody>
          </Modal>

              {/*Item breakup details modal       */}
              <Modal
            size="xl"
            isOpen={itemDetailsModal}
            toggle={() => setItemDetailsModal(!itemDetailsModal)}
          >
            <ModalHeader toggle={() => setItemDetailsModal(!itemDetailsModal)}>
              {" "}
              <Link
                to="#"
                onClick={() => {
                  printDiv("printDivitem");
                }}
                className="btn btn-sm btn-success mr-2"
              >
                <i className="fa fa-print"></i> Print
              </Link>
            </ModalHeader>
            <ModalBody>
              <Row id="printDivitem">
                <Col lg={12}>
                      <CardTitle className="text-center">
                        {props.t("Branchwise Balance Item Report")}
                        </CardTitle>
                    
                  <CardTitle className="text-center">
                    {props.t("Item Details")}
                  </CardTitle>
                  <CardTitle className="text-center">
                    {props.t("(Item Balance Details)")}
                  </CardTitle>
                  <Card>
                    <CardBody>
                      <Row>
                        <Col lg={12}>
                        {/* <div className="d-flex justify-content-between align-items-center mb-3"> */}
                        <div className="mb-1" style={{display:"flex", justifyContent:"space-between",alignItems:"center",padding:"0px"}}>
        <div>
          <h5 className="mb-0">Branch: {selectedBranch?.name}</h5>
        </div>
        <div>
          <h5 className="mb-0">
            Total Qty: {formatUnitsForReport(filterModalTotalQty)}
          </h5>
        </div>
        <div>
          <h5 className="mb-0">Total: {Number(filterModalSubTotal).toLocaleString('en-QA', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2
})}</h5>
        </div>
      </div>  
                          <BootstrapTable
                            keyField="_id"
                            data={itemDetailsLevel2 && itemDetailsLevel2}
                            columns={columnsItemDetails}
                            striped
                            bootstrap4
                            filter={filterFactory({
                              afterFilter: (newResult, targetColumn) => {
                                setTimeout(() => {
                                  afterFilterForDetails(newResult,"quantity","")
                                }, 200);
                                return newResult;
                              }
                            })}
                            hover
                            condensed
                            noDataIndication={
                              isLoadingItemDetails ? (
                                <Spinner size="md" />
                              ) : (
                                props.t("No data to display.")
                              )
                            }
                          />
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </ModalBody>
          </Modal>
        </Container>
      </div>
    </React.Fragment>
  );
};
const mapStatetoProps = (state) => {};
export default withRouter(
  connect(
    mapStatetoProps,
    {}
  )(withNamespaces()(BranchwiseItemBalanceInventoriesReport))
);
